/* eslint-disable no-unused-vars, no-empty */
import QUERY from 'query-string'

import rpc, { tracing } from './utils/rpc'
import Worker from './rpc.worker'

const workerUrl = (Worker.toString().match(/"(.*?)"/) || [])[1]

let worker = null
let client = null

try {
  worker = new SharedWorker(process.env.PUBLIC_PATH + workerUrl)
  client = rpc(
    worker.port.addEventListener.bind(worker.port),
    worker.port.postMessage.bind(worker.port)
  )
} catch (_) {}

const getLoginStatus = (payload) => {
  const { sponsorId } = payload || {}
  let isLoginSponsor = sessionStorage.getItem('isLoginSponsor')
  isLoginSponsor = isLoginSponsor === 'true'
  let userInfo = null
  try { userInfo = JSON.parse(sessionStorage.getItem('userInfo') || 'null') || null }
  catch (_) { }
  if (sponsorId && userInfo && userInfo.sponsorId !== sponsorId) {
    isLoginSponsor = false
    userInfo = null
  }
  return { isLoginSponsor, userInfo }
}

if (client) client.onRequest = (call) => {
  const { action, payload } = call || {}
  // console.log('onRpcRequest', action, payload)
  switch (action) {
    case 'getLoginStatus': {
      if (!(payload || {}).sponsorId) return
      const status = getLoginStatus(payload) || {}
      // console.log('local login status', status)
      return status.userInfo ? status : undefined
    }
    default:
  }
}

if (worker) worker.port.start()

const enter = history => Promise.resolve().then(() => {
  if (!history) return
  // eslint-disable-next-line prefer-const
  let { sponsorId, state, ...query } = QUERY.parse(history.location.search)
  sponsorId = parseInt(sponsorId, 10)
  if (getLoginStatus().userInfo || !sponsorId) return

  try { state = JSON.parse(state) } catch (_) { state = {} }
  history.replace({
    pathname: history.location.pathname,
    search: QUERY.stringify(query),
    state,
  })

  return client && client.request({ action: 'getLoginStatus', payload: { sponsorId } }, 800)
    .then(({ result: status, trace }) => {
      console.log('remote login status', status)
      // tracing(trace)
      if (!(status || {}).userInfo) return
      Object.entries(status).forEach(([key, value]) => sessionStorage.setItem(key, JSON.stringify(value)))
    })
    .catch(() => false)
})

export default enter
